exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title[data-v-8faf322a] {\n  background-size: 100%;\n}\n.list-item[data-v-8faf322a] {\n  font-size: 0.9em;\n  font-weight: 600;\n  padding: 6% 3%;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  -moz-column-gap: 3%;\n       column-gap: 3%;\n  row-gap: 1em;\n}\n.item-content[data-v-8faf322a] {\n  color: #95693f;\n  font-size: 1.15em;\n  border-radius: 0.7em;\n  background-color: #faf8ee;\n  padding: 4% 0;\n  text-align: center;\n  border: 0.2em solid #dfcfa5;\n  box-shadow: 0 0.2em #dfcfa5;\n}\n", ""]);

// exports
